let items: any[] = [];

export const navItems: any[] = items;